import { AppType, BuildType, Environment } from '@domains';

export const environment: Environment = new Environment({
  production: true,
  app: AppType.TPL,
  buildType: BuildType.DEV,
});
